import config from "appConfig";
import { LayoutComponents } from "packages/lesson/dist/@types";

const components: LayoutComponents = [
  {
    variant: "layout",
    data: {
      type: "table",
      options: {
        cols: 4,
        rows: 4,
        colSpan: {
          "0:0": 2,
        },
        rowSpan: {
          "0:0": 4,
        },
        colsSize: [1.9, 0.1, 0.1, 1.9],
        rowsSize: [0.5, 0.5, 0.5, 0.5],
        components: [
          [
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/scenario-2-2.svg`,
                  },
                },
              },
            },
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `ADDING DEPARALLISED LININGS INSIDE THE CIRCULAR SHAPE`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 700,
                      lineHeight: "18px",
                      fontSize: "16px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-end",
                  justifyContent: "flex-start",
                  paddingBottom: "5%",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-sad.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">COST SAVINGS</span><br />Another acoustic treatment has been added inside the circular walls to make this space suitable for music. However,`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-neutral.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">SPACE SAVINGS</span><br />Technical components can be integrated behind these wall linings (ventilation ducts, electrical plugs, etc.) which finally will save some extra cost and space.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      textAlign: "left",
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
          [
            null,
            null,
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "image",
                  options: {
                    src: `${config.ASSETS_URL}/05/30/principle/smile-happy-dark.svg`,
                    styles: {
                      width: "20px",
                      height: "20px",
                    },
                  },
                },
                styles: {
                  justifyContent: "flex-end",
                  alignItems: "flex-start",
                },
              },
            },
            {
              variant: "blockContainer",
              data: {
                block: {
                  type: "text",
                  options: {
                    data: `<span style="font-size: 16px; font-weight: 700;">ACOUSTICALLY</span><br />For music space, a random shape with no circular surfaces nor parallel reflective surfaces is recommended as it avoids unwanted acoustic effects such as focusing points and flutter echoes.`,
                    scrollbars: false,
                    formatter: "html",
                    styles: {
                      fontWeight: 400,
                      lineHeight: "18px",
                      fontSize: "14px",
                    },
                  },
                },
                styles: {
                  alignItems: "flex-start",
                  justifyContent: "flex-start",
                },
              },
            },
          ],
        ],
      },
    },
  },
];

export default components;
